import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Barcode } from './barcode';
import { environment } from '../../environments/environment';
import { BBResponseContainer } from '../carrier/response-container';
import { Subject } from 'rxjs';
import { timeout } from 'rxjs/operators';

@Injectable()
export class BarcodeScanService {

  
  constructor(private http: HttpClient) {
  }

  saveBarcode(barcode: Barcode) {
    let url = environment.BB_MAIL_RECEPTION_URL + 'barcode';
    return this.http.post<BBResponseContainer>(url, barcode).pipe(timeout(environment.defaultTimeout));
  }

    //shared Methods
    // Observable string sources
    private emitChangeSource = new Subject<any>();
    // Observable string streams
    changeEmitted$ = this.emitChangeSource.asObservable();
    // Service message commands
    emitChange(change: any) {
        console.log("emit change");
        this.emitChangeSource.next(change);
    }

}
